<template>
  <span
    v-if="colorMap[country.toLowerCase()] === undefined"
    class="country-code"
    :style="textStyle"
    >{{ country.toUpperCase() }}</span
  >
  <span v-else class="country-badge">
    <span class="country-code" :style="textStyle">{{ country.toUpperCase() }}</span>
    <img
      v-if="shouldShowFlag"
      :src="flagSrc"
      :alt="country + ' flag'"
      class="country-flag"
      style="border: 1px solid black; margin-right: 4px; vertical-align: middle;"
    />
  </span>
</template>

<script>
export default {
  name: 'CountryBadge',
  props: {
    country: {
      type: String,
      required: true,
      default: '-',
    },
  },
  data() {
    return {
      countryCodeMap: {
        uk: 'GB',
      },
      colorMap: {
        us: 'linear-gradient(to right, #B31942, #0A3161)',
        uk: 'linear-gradient(to right, #C8102E, #012169)',
        ca: '#FF0000',
        au: 'linear-gradient(to right, #FF0000, #012169)',
        de: 'linear-gradient(to right, #000000, #DD0000)',
        fr: 'linear-gradient(to right, #002395, #ED2939)',
        jp: '#BC002D',
        cn: 'linear-gradient(to right, #DE2910, #FFDE00)',
        kr: 'linear-gradient(to right, #000000, #0047A0)',
        in: 'linear-gradient(to right, #FF9933, #138808)',
        br: 'linear-gradient(to right, #009c3b, #FFDF00)',
        mx: 'linear-gradient(to right, #006847, #CE1126)',
        es: 'linear-gradient(to right, #AA151B, #F1BF00)',
        it: 'linear-gradient(to right, #008C45, #CD212A)',
        ru: 'linear-gradient(to right, #0039A6, #D52B1E)',
        default: '#374457',
      },
    };
  },
  computed: {
    textStyle() {
      const gradient = this.colorMap[this.country.toLowerCase()] || this.colorMap.default;
      return {
        background: gradient,
        '-webkit-background-clip': 'text',
        'background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
        color: 'transparent',
      };
    },
    flagSrc() {
      let countryCode = this.country.toLowerCase();
      // Check if we need to use a different code
      countryCode = this.countryCodeMap[countryCode]?.toLowerCase() || countryCode;
      return `https://flagcdn.com/w20/${countryCode}.png`;
    },
    shouldShowFlag() {
      const lowercaseCountry = this.country.toLowerCase();
      return lowercaseCountry !== 'default' && this.colorMap[lowercaseCountry] !== undefined;
    },
  },
};
</script>

<style scoped>
.country-badge {
  display: inline-flex;
  align-items: center;
  background-color: rgb(255, 255, 255);
  border-radius: 20px;
  border: 1px solid #e0e0e0;
  padding: 4px 8px;
  font-weight: bold;
}

.country-flag {
  width: 20px;
  height: auto;
  margin-left: 6px;
}

.country-code {
  font-weight: 1000;
  font-size: 0.9em;
}
</style>
